import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'nickname',
    pathMatch: 'full',
  },
  {
    path: 'nickname',
    loadComponent: () =>
      import('./features/nickname/nickname-page').then(
        (m) => m.NicknamePage,
      ),
  },
  {
    path: 'scanner',
    loadComponent: () =>
      import('./features/scanner/scanner-page').then((m) => m.ScannerPage),
  },
  {
    path: 'race/active',
    loadComponent: () =>
      import('./features/race/race-active').then((m) => m.RaceActive),
  },
  {
    path: 'race/result/:runId',
    loadComponent: () =>
      import('./features/race/race-result').then((m) => m.RaceResult),
  },
  {
    path: 'classifica/:slug',
    loadComponent: () =>
      import('./features/leaderboard/leaderboard-page').then(
        (m) => m.LeaderboardPage,
      ),
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./features/admin/admin-login').then((m) => m.AdminLogin),
  },
  {
    path: 'admin/dashboard',
    loadComponent: () =>
      import('./features/admin/admin-dashboard').then(
        (m) => m.AdminDashboard,
      ),
  },
  {
    path: 'admin/chips',
    loadComponent: () =>
      import('./features/admin/admin-chips').then((m) => m.AdminChips),
  },
  {
    path: 'admin/leaderboards',
    loadComponent: () =>
      import('./features/admin/admin-leaderboards').then(
        (m) => m.AdminLeaderboards,
      ),
  },
  {
    path: 'admin/runs',
    loadComponent: () =>
      import('./features/admin/admin-runs').then((m) => m.AdminRuns),
  },
  {
    path: '**',
    redirectTo: 'nickname',
  },
];
